import type { ServiceDirection } from './analyticsSupport';

export const BUYER_EXTRA_DIRECTIONS: ServiceDirection[] = [
  {
    title: 'Международные выставки',
    popup: {
      title: 'Международные выставки',
      index: '',
      separator: '',
      leadOnNextLine: true,
      lead: 'Организация участия в рамках международного конгрессно-выставочного мероприятия с коллективным выставочным стендом экспортно ориентированных субъектов промышленной деятельности и/или АПК города Москвы на безвозмездной основе.',
      advantagesTitle: 'Участнику предоставляются следующие сервисы и услуги:',
      advantagesMarker: 'decimal',
      advantages: [
        'Услуги по организации рабочего места в рамках коллективной экспозиции',
        'Услуги по организации и проведению индивидуальных b2b-встреч с зарубежными партнерами',
        'Услуги по организации и проведению обучающего мероприятия для подготовки к проведению индивидуальных b2b-встреч с зарубежными партнерами',
        'Услуги по организации и проведению установочных встреч для подготовки к проведению индивидуальных b2b-встреч с зарубежными партнерами',
        'Услуги переводчиков на время подготовки и проведения индивидуальных b2b-встреч с зарубежными партнёрами',
        'Логистика выставочных образцов',
      ],
      advantageEnds: [';', ';', ';', ';', ';', '.'],
    },
  },
  {
    title: 'Международные бизнес-миссии',
    popup: {
      title: 'Международные бизнес-миссии',
      index: '',
      separator: '',
      leadOnNextLine: true,
      lead: 'Организация и проведение международных бизнес-миссий, организация участия экспортно ориентированных субъектов промышленной деятельности и агропромышленного комплекса города Москвы в международных бизнес-миссиях.',
      advantagesTitle: '',
      advantagesMarker: 'decimal',
      advantages: [
        'Услуги по организации и проведению индивидуальных b2b-встреч с зарубежными партнерами',
        'Услуги переводчиков на время подготовки и проведения мероприятий, включенных в программу Бизнес-миссии.',
        'Трансфер внутри страны пребывания согласно программе мероприятий, включая встречу/проводы в аэропорт, от места размещения (отель/гостиница) к месту проведения мероприятий бизнес-миссии и обратно. Данный сервис предоставляется в рамках проведения Бизнес-миссии в офлайн формате.',
        '(если применимо) Аренда площадки (конференц-зал, переговорные комнаты, необходимое презентационное оборудование для демонстрации продукции) и необходимого демонстрационного оборудования для организации мероприятий Бизнес-миссии.',
        'Консультирование Участников по вопросам бронирования авиабилетов, гостиниц, получения визы в страну проведения Бизнес-миссии.',
        'Организация видеоконференции через онлайн-сервисы для проведения мероприятий Бизнес-миссии и b2b-встреч в онлайн формате. Данный сервис предоставляется в рамках проведения Бизнес-миссии в онлайн формате.',
      ],
      advantageEnds: [';', '', '', '', '', ''],
    },
  },
];
